import { render } from "./CalculationItemMaterialSelector.vue?vue&type=template&id=127308ad"
import script from "./CalculationItemMaterialSelector.vue?vue&type=script&lang=js"
export * from "./CalculationItemMaterialSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__